import React from 'react'
import {Button } from '@material-ui/core'
import { Link } from 'react-router-dom'


function HomePage(props) {
	const { classes } = props
	const baseURL = process.env.PUBLIC_URL;

	return (
		<main className="home">
			<img className="logoLogin" src={require('../../images/logo.svg')} />
			<h3 className="titleLogin">RESERVAS - SEDE CHAMARTIN</h3>
			<h6 className="titleLogin">Calle Agustín de Foxá, 25, Bajo C, 28036 Madrid</h6>
			<div className="btnContainer">
				<Link to={baseURL+"/login"}><div class="loginBtnPrincipal">Acceder</div></Link>
				<span></span>
				<Link to={baseURL+"/register"}><div class="loginBtnSecundary">Soy nuevo usuario</div></Link>
			</div>
		</main>
	)
}

export default HomePage;